<button *ngIf="form && checkComponent()" matTooltip="Cliente Contattato" type="button"
class="my-bounce btn closeRequestButton mx-2" (click)="openModal()" [disabled]="disabled()">
{{ 'REQUEST.clienteContattato' | translate }}
</button>